
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Ampullary_carcinoma_of_Vater",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Ampullary_carcinoma_of_Vater.vue